module.exports = "<div><div ng-view></div><div class=loading-overlay ng-show=viewport.loaderContext.showOverlay><div class=ajax-loader></div></div><div class=partial-loading-overlay ng-show=viewport.loaderContext.showPartialOverlay></div><div class=partial-modal-overlay ng-show=viewport.loaderContext.showModalOverlay></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/components/viewport/viewport.html
// module id = 136
// module chunks = 0